import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import ClassificacaoTributariaService from 'business/cadastro/fiscal/classificacaoTributaria/classificacaoTributariaService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { createCodeDescriptionObject, } from 'helper/formater'
import { errorToToast } from 'helper/error'

import CstrService from 'business/cadastro/fiscal/cstr/cstrService'
import TipoAliquotaService from 'business/cadastro/fiscal/tipoAliquota/tipoAliquotaService'

export default function ClassificacaoTributaria() {

    const [service] = useState(() => new ClassificacaoTributariaService())
    const [cstrs, setCstrs] = useState([])
    const [tipoAliquotas, setTipoAliquotas] = useState([])

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.cstr) {
            setCstrs([createCodeDescriptionObject(data.cstr, 'codigo_cstr', 'descricao_cstr', true)])
        }
        if (data?.tipo_aliquota) {
            setTipoAliquotas([createCodeDescriptionObject(data.tipo_aliquota, 'codigo_tipali', 'descricao_tipali', true)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadCstrs = async () => {
        const srv = new CstrService()
        await srv.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_cstr', 'descricao_cstr', true))
            setCstrs(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoAliquotas = async () => {
        const srv = new TipoAliquotaService()
        await srv.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tipali', 'descricao_tipali', true))
            setTipoAliquotas(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-12 lg:col-12 xl:col-12" field="descricao_clastrib" form={form} service={service} type="textarea" rows={3} label="Classificação" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="exige_trib_clastrib" form={form} service={service} type="switch" label="Exige tributação" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_red_bc_cst_clastrib" form={form} service={service} type="switch" label="Redução de BC" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_red_aliq_clastrib" form={form} service={service} type="switch" label="Tem redução de alíquota" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_transf_cred_clastrib" form={form} service={service} type="switch" label="Permite transferência de crédito" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_diferimento_clastrib" form={form} service={service} type="switch" label="Possui diferimento" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_monof_clastrib" form={form} service={service} type="switch" label="É monofásico" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_cred_presum_ibs_zfm_clastrib" form={form} service={service} type="switch" label="Crédito presumido IBS/ZFM" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_ajuste_compet_clastrib" form={form} service={service} type="switch" label="Possui ajuste por competência" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="perc_red_ibs_clastrib" form={form} service={service} type="number" label="% redução IBS" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="perc_red_cbs_clastrib" form={form} service={service} type="number" label="% redução CBS" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_trib_regular_clastrib" form={form} service={service} type="switch" label="É tributação regular" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_cred_presum_clastrib" form={form} service={service} type="switch" label="Crédito presumido geral" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_estorno_cred_clastrib" form={form} service={service} type="switch" label="Tem estorno de crédito" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_trib_monof_normal_clastrib" form={form} service={service} type="switch" label="Tributação monofásica normal" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_trib_monof_suj_reten_clastrib" form={form} service={service} type="switch" label="Tributação monofásica com retenção" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_trib_monof_retid_ant_clastrib" form={form} service={service} type="switch" label="Tributação monofásica com retenção anterior" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_trib_monof_comb_difer_clastrib" form={form} service={service} type="switch" label="Tributação monofásica de combustível com diferimento" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfe_clastrib" form={form} service={service} type="switch" label="NFe" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfce_clastrib" form={form} service={service} type="switch" label="NFCe" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_cte_clastrib" form={form} service={service} type="switch" label="CTe" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_cte_os_clastrib" form={form} service={service} type="switch" label="CTe OS" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_bpe_clastrib" form={form} service={service} type="switch" label="BP-e" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nf3e_clastrib" form={form} service={service} type="switch" label="NF3e" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfcom_clastrib" form={form} service={service} type="switch" label="NFCom" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfse_clastrib" form={form} service={service} type="switch" label="NFSe" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_bpe_tm_clastrib" form={form} service={service} type="switch" label="BP-e TM" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_bpe_ta_clastrib" form={form} service={service} type="switch" label="BP-e TA" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfag_clastrib" form={form} service={service} type="switch" label="NFAg" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfsvia_clastrib" form={form} service={service} type="switch" label="NFSe via" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfabi_clastrib" form={form} service={service} type="switch" label="NFAbI" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_nfgas_clastrib" form={form} service={service} type="switch" label="NFGas" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="para_dere_clastrib" form={form} service={service} type="switch" label="DeRE" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="num_anexo_clastrib" form={form} service={service} type="number" label="Número do anexo" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-6" field="url_legislacao_clastrib" form={form} service={service} type="text" clearString label="Legislação" />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_cstr_clastrib" form={form} type="dropdown2" service={service} label="Código da situação tributária"
                            optionKey='codigo_cstr'
                            optionLabel='descricao_cstr'
                            options={cstrs}
                            onLoad={loadCstrs}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tipali_clastrib" form={form} type="dropdown2" service={service} label="Código do tipo de alíquota"
                            optionKey='codigo_tipali'
                            optionLabel='descricao_tipali'
                            options={tipoAliquotas}
                            onLoad={loadTipoAliquotas}
                        />

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
